if (!customElements.get('tpl-bundle-gallery-controls')) {
  customElements.define('tpl-bundle-gallery-controls', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      customElements.whenDefined('media-gallery').then(() => {
        if (!this.isConnected) return;
        this.gallery = this.closest('media-gallery');
        this.viewer = this.gallery?.querySelector('[id^="GalleryViewer"]');
        this.slider = this.viewer?.querySelector('[id^="Slider-Gallery"]');
        if (!this.gallery || !this.viewer || !this.slider) return;
        if (this.items.length < 2) {
          this.hidden = true;
          return;
        }
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-gallery-direction]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          this.move(Number(button.dataset.galleryDirection));
        });
        this.addEventListener('keydown', (event) => {
          if (!event.target.closest('button')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
      });
    }

    get items() {
      return Array.from(this.slider.children).filter((item) => item.matches('[data-media-id]'));
    }

    move(direction) {
      const items = this.items;
      if (items.length < 2 || typeof this.gallery.setActiveMedia !== 'function') return;
      const selectedThumbnail = this.gallery.querySelector('[id^="GalleryThumbnails"] button[aria-current="true"]');
      const thumbnailId = selectedThumbnail?.closest('[data-target]')?.dataset.target;
      let currentIndex = items.findIndex((item) => item.dataset.mediaId === thumbnailId);
      if (window.matchMedia('(max-width: 749px)').matches) {
        const sliderLeft = this.slider.getBoundingClientRect().left;
        const visibleItems = items.map((item, index) => ({
          index,
          rect: item.getBoundingClientRect(),
        })).filter(({ rect }) => rect.width > 0 && rect.height > 0);
        if (visibleItems.length) {
          visibleItems.sort((a, b) => Math.abs(a.rect.left - sliderLeft) - Math.abs(b.rect.left - sliderLeft));
          currentIndex = visibleItems[0].index;
        }
      }
      if (currentIndex < 0) currentIndex = items.findIndex((item) => item.classList.contains('is-active'));
      const nextIndex = ((currentIndex < 0 ? 0 : currentIndex) + direction + items.length) % items.length;
      this.gallery.setActiveMedia(items[nextIndex].dataset.mediaId, false);
    }
  });
}
